export default "__VITE_ASSET__sjJkEUnT__"